import { render, staticRenderFns } from "./UomForm.vue?vue&type=template&id=0fc1e2c8"
import script from "./UomForm.vue?vue&type=script&lang=js"
export * from "./UomForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports